import { useContext } from 'react';
import ToastContext from './HDSToastContextProvider.js';
export default function useToast() {
    const ctx = useContext(ToastContext);
    if (!ctx) {
        throw new Error('The `useToast` hook must be called from a descendent of `HDSToastContextProvider`');
    }
    return {
        addToast: ctx.addToast,
    };
}
//# sourceMappingURL=useToast.js.map